module.exports = __webpack_public_path__ + "img/icons-zaki.9beaa11.svg";